import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_FUEL_RESET = 'DELETE_FUEL_RESET';
export const DELETE_FUEL_LOADING = 'DELETE_FUEL_LOADING';
export const DELETE_FUEL_SUCCESS = 'DELETE_FUEL_SUCCESS';
export const DELETE_FUEL_REJECT = 'DELETE_FUEL_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteFuelReset = () => ({ type: DELETE_FUEL_RESET });
export const deleteFuelLoading = () => ({ type: DELETE_FUEL_LOADING });
export const deleteFuelSuccess = (payload) => ({ type: DELETE_FUEL_SUCCESS, payload });
export const deleteFuelReject = (payload) => ({ type: DELETE_FUEL_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteFuelRequest = async (getState, id) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/Fuels/web/DeleteFuels?id=${id}`, options);
};